import styled, {keyframes} from 'styled-components';

import {Hint} from 'components/ui-kit/Hint';
import {Icon} from 'components/ui-kit/Icon';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {Title} from 'components/ui-kit/Title';
import {breakpoint, colors} from 'theme';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    color: ${colors.black};
    min-height: calc(100vh - 120px);
`;

export const AuthImage = styled.div`
    display: none;
    flex: 1;
    background-color: ${colors.brandPrimary};
    overflow-x: hidden;

    img {
        width: 100%;
        max-width: 800px;
        min-width: 500px;
        -webkit-user-drag: none;
    }

    @media (min-width: ${breakpoint.tablet}) {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        align-items: center;
    }
`;

export const AuthContent = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: ${colors.white};
    padding: 20px 20px;
    box-sizing: border-box;
    flex: 1;

    @media (min-width: ${breakpoint.desktop}) {
        padding: 40px 60px;
    }
`;

export const LanguageWrapper = styled.div`
    position: absolute;
    top: 20px;
    right: 10px;
`;

export const ServiceTitle = styled(Title)`
    text-align: center;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 40px;
    color: #fff;
    background-color: ${colors.brandPrimary};
    margin: 0;
    padding: 40px 100px;
    box-sizing: border-box;

    & > svg {
        vertical-align: middle;
    }

    path {
        fill: #fff;
    }
`;

export const CustomDatamatrixIcon = styled(Icon)`
    margin-right: 10px;
`;

export const AuthTitle = styled(Title)`
    display: flex;
    margin-bottom: 15px;
    font-weight: 500;

    @media (min-width: ${breakpoint.desktop}) {
        margin-top: 40px;
        margin-bottom: 30px;
    }
`;

export const AuthDescription = styled.p`
    text-align: center;
    font-weight: 400;
    font-size: 14px;

    @media (min-width: ${breakpoint.desktop}) {
        margin-bottom: 30px;
    }
`;

export const CollapsableContainer = styled.div<{collapsed?: boolean}>`
    display: grid;
    grid-template-rows: ${(p) => (p.collapsed ? '1fr' : '0fr')};
    transition: all 0.15s ease-in-out;
`;

export const FormSubtitle = styled.p<{collapsed: boolean}>`
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    & svg {
        transform: ${(p) => p.collapsed && 'rotate(-180deg)'};
        transition: transform 0.15s ease-in-out;
    }

    @media (min-width: ${breakpoint.desktop}) {
        margin-bottom: 30px;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    bottom: 0;
    background: ${colors.white};
    padding: 10px 0;

    & > * {
        max-width: 198px;
    }
`;

export const CustomContentContainer = styled(ContentContainer)`
    padding: 0;
    width: 100%;
    max-width: 450px;
`;

export const FormFields = styled.div`
    display: grid;
    grid-row-gap: 10px;
    grid-column-gap: 30px;
    margin-bottom: 20px;
    overflow: hidden;
`;

export const Field = styled(Hint)`
    display: flex;
    flex-flow: column wrap;

    > span {
        font-size: 12px;
        color: ${colors.textSecondary};
        padding-bottom: 6px;
        margin-top: 2px;
    }
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    height: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 80px;

    animation: ${opacity} 2s ease;
`;

export const CheckboxLabel = styled.div`
    font-size: 14px;
    color: ${colors.textPrimary};
`;
